export const ChartState = {
    LOADING: 'Loading',
    SHOWING: 'Showing',
    ERROR: 'Error',
    NO_DATA: 'No_Data',
    INCOMPLETE_RANGE: 'Incomplete_Range'
}

export function toISODate(date) {
    return date.toISOString().split('T')[0]
}

export function getDefaultDates() {
    const today = new Date()
    // First of last month (UTC, like the backend's month buckets), so the first bar covers a full month
    const defaultStart = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1))
    return { today, defaultStart }
}
